import { getTokenAndFetchHeaders } from '../utils';
import { apiRequest } from '../utils/authConfig';
import { AuthContext } from '../utils/authContext';

export class EmailService {
    private _apikey: string;
    private _api: string;
    context: AuthContext;
    constructor(context: AuthContext) {
        this._apikey = process.env.REACT_APP_BACKEND_KEY ? process.env.REACT_APP_BACKEND_KEY : '';
        this._api = process.env['REACT_APP_BACKEND_URL'] ? process.env['REACT_APP_BACKEND_URL'] : '';
        this.context = context;
    }
    private getHeaders(){
        return getTokenAndFetchHeaders(this.context.getToken, apiRequest, this._apikey);
    }
    async verify(toUrl?: string){
        const headers = await this.getHeaders();
        const url = toUrl ? toUrl : process.env['REACT_APP_URL'] + '?verified=true';
        const paramUrl = encodeURIComponent(url);
        try {
            return await fetch(`${this._api}/email/verify?toUrl=${paramUrl}`, {
                method: 'GET',
                headers,
            });
        } catch (err: any) {
            console.error(err);
        }
    }
    async confirm(token: string) {
        const headers = await this.getHeaders();
        try {
            return await fetch(`${this._api}/email/confirm?token=${token}`, {
                method: 'GET',
                headers,
            });
        } catch (err: any) {
            console.error(err);
        }
    }
}